<template>
	<n-dropdown :options placement="bottom-end" trigger="click" @select="handleSelect">
		<ProfileAvatar :size="32" class="cursor-pointer" />
	</n-dropdown>
</template>

<script lang="ts" setup>
import type { I18nString } from "@/lang/config"
import { NDropdown } from "naive-ui"
import { ref } from "vue"
import { useI18n } from "vue-i18n"
import { useRouter } from "vue-router"
import ProfileAvatar from "@/components/profile/ProfileAvatar.vue"
import { ICONS } from "@/const"
import { renderIcon } from "@/utils"

const router = useRouter()
const { t } = useI18n()
const options = ref([
	{
		label: t<I18nString>(`navigation.menu.profile`),
		key: "route-Profile",
		icon: renderIcon(ICONS.pages.profile)
	},
	/*
	{
		label: () =>
			h(
				"a",
				{
					href: "#",
					target: "_blank",
					rel: "noopenner noreferrer"
				},
				t<I18nString>(`navigation.menu.settings`)
			),
		key: "settings",
		icon: renderIcon(ICONS.pages.settings)
	},
	*/
	{
		label: t<I18nString>(`navigation.menu.logout`),
		key: "route-Logout",
		icon: renderIcon(ICONS.pages.logout)
	}
])
function handleSelect(key: string) {
	if (key.indexOf("route-") === 0) {
		const path = key.split("route-")[1]
		router.push({ name: path })
	}
}
</script>
